import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { debounceTime, take, takeUntil } from 'rxjs/operators';
import { NavigationControlFacade, SlideViewerFacade, TrainingSharedFacade } from '@medsurf/flat-facades';
import { FeedbackControlService } from '@medsurf/flat-services';

@Component({
    selector: 'medsurf-training-slider',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './training-slider.component.html',
    styleUrls: ['./training-slider.component.scss'],
    standalone: false
})
export class TrainingSliderComponent implements OnDestroy {
  /**
   * Members
   */
  private _destroyed$ = new Subject<boolean>();

  /**
   * Constructor
   *
   * @param trainingSharedFacade
   * @param slideViewerFacade
   * @param feedbackControlService
   * @param navigationControlFacade
   * @param route
   */
  public constructor(public trainingSharedFacade: TrainingSharedFacade,
                     public slideViewerFacade: SlideViewerFacade,
                     public feedbackControlService: FeedbackControlService,
                     public navigationControlFacade: NavigationControlFacade,
                     public route: ActivatedRoute) {
    this.trainingSharedFacade.requestTrainingNodesBySelectedSlides();
    // Check If There Are Any Slide Results Set; Otherwise Return to The Start
    // Debounce since not all nodes are loaded at the same time
    this.trainingSharedFacade.isTrainingSetupCorrectly$.pipe(takeUntil(this._destroyed$), debounceTime(1000)).subscribe((isTrainingSetupCorrectly) => {
      if (isTrainingSetupCorrectly === false) {
        this.trainingSharedFacade.trainingSetupIncorrectlyUrl$.pipe(take(1)).subscribe(url => this.navigationControlFacade.requestNavigate([url]));
      }
    })
    // Load Next Slide Data
    this.trainingSharedFacade.nextSlideNode$.pipe(takeUntil(this._destroyed$)).subscribe((slide) => {
      if (slide && slide.page) {
        this.slideViewerFacade.requestGetSlideDataByPageId(slide.page as unknown as string);
      }
    });
    // Load Previous Slide Data
    this.trainingSharedFacade.previousSlideNode$.pipe(takeUntil(this._destroyed$)).subscribe((slide) => {
      if (slide && slide.page) {
        this.slideViewerFacade.requestGetSlideDataByPageId(slide.page as unknown as string);
      }
    });
  }

  /**
   * Ng On Destroy
   */
  public ngOnDestroy(): void {
    this._destroyed$.next(true);
    this._destroyed$.complete();
  }
}
